import axiosInstance from '../axiosInstance'; // Asegúrate de que esta ruta sea correcta

// Obtener todos los componentes activos
export const fetchComponents = async () => {
  const response = await axiosInstance.get('/maintenance/components'); 
  return response.data;
};

// Obtener un componente por ID
export const fetchComponentById = async (id) => {
  if (!id) throw new Error("comId requerido");
  const response = await axiosInstance.get(`/maintenance/components/${id}`);
  return response.data;
};

// *** NUEVA FUNCIÓN: Obtener componentes por ID de vehículo ***
export const fetchComponentsByVehicleId = async (vehId) => {
  const response = await axiosInstance.get(`/maintenance/components/vehicle/${vehId}`);
  return response.data;
};

// Crear un componente
export const createComponent = async (data) => {
  const response = await axiosInstance.post('/maintenance/components', data);
  return response.data;
};

// Actualizar un componente
export const updateComponent = async ({ id, data }) => {
  const response = await axiosInstance.put(`/maintenance/components/${id}`, data); 
  return response.data;
};

// Eliminar (lógicamente) un componente
export const deleteComponent = async ({ id, updbyid }) => { 
  const response = await axiosInstance.delete(`/maintenance/components/${id}`, { data: { updbyid } });
  return response.data;
};